<template>
  <div id="app">
    <sidebar :toggleNotes="toggleNotes"></sidebar>
    <b-button class="toggleButton" :class="{toggleButtonToggled : toggleNotes}" 
              pill variant="outline-dark" :pressed.sync="toggleNotes">Notes</b-button>

    <div id="container" :class="{containerToggle:toggleNotes}">
    <HelloWorld msg="Monster Builder"/>
      <div class="item">
      </div>
      <div class="item">
        <statBlock :traits="traits_monster"
                  :actions="action_monster"
                  :legend_actions="legend_action_monster"></statBlock>
      </div>
      <div class="item">
        <div>
          <b-tabs class="tabs" content-class="mt-3" v-model="tabIndex" fill @activate-tab="query = ''; searchClick = false">
            <b-tab title="Proficiencies" disabled><p>I'm a disabled tab!</p></b-tab>
            <b-tab title="Traits" active>
              <!-- BUTTONS -->
              <p class="h4 mb-2" style="margin : 20px">
                <b-icon-funnel class="test" @click="traitSort"></b-icon-funnel>
                <transition name="queryAnimation">
                  <input ref="query" class="queryBox"  v-show="searchClick" v-model="query">
                </transition>
                <b-icon-search style="margin-left:20px" class="test" @click="searchClick = !searchClick"></b-icon-search>
                <!-- <transition name="filterAnimation">
                  <b-icon-filter class="filterButton" style="margin-left:20px" @click="reverseList"></b-icon-filter>
                </transition> -->
              </p>
                <virtual-list class="list-dynamic scroll-touch"
                  :data-key="'uid'"
                  :data-sources="filteredTraits"
                  :data-component="propertyComponent"
                  :extra-props="{tabIndex}"

                  :estimate-size="50"
                  :item-class="'list-item-dynamic'"/>
              <!-- </transition-group> -->
            </b-tab>
            <b-tab title="Actions" lazy>
              <p class="h4 mb-2" style="margin : 20px">
                <b-icon-funnel class="test" @click="actionSort"></b-icon-funnel>
                <transition name="queryAnimation">
                  <input ref="query" class="queryBox"  v-show="searchClick" v-model="query">
                </transition>
                <b-icon-search style="margin-left:20px" class="test" @click="searchClick = !searchClick"></b-icon-search>
                <!-- <b-icon-filter class="filterButton" style="margin-left:20px"></b-icon-filter> -->
              </p>
               <virtual-list class="list-dynamic scroll-touch"
                :data-key="'uid'"
                :data-sources="filteredAction"
                :data-component="propertyComponent"
                :extra-props="{tabIndex}"

                :estimate-size="50"
                :item-class="'list-item-dynamic'"/>
            </b-tab>
            <b-tab title="Legendary Actions" lazy>
              <p class="h4 mb-2" style="margin : 20px">
                <b-icon-funnel class="test" @click="legendActionSort"></b-icon-funnel>
                <transition name="queryAnimation">
                  <input ref="query" class="queryBox"  v-show="searchClick" v-model="query">
                </transition>
                <b-icon-search style="margin-left:20px" class="test" @click="searchClick = !searchClick"></b-icon-search>
                <!-- <b-icon-filter class="filterButton" style="margin-left:20px"></b-icon-filter> -->
              </p>
               <virtual-list class="list-dynamic scroll-touch"
                :data-key="'uid'"
                :data-sources="filteredLegendAction"
                :data-component="propertyComponent"
                :extra-props="{tabIndex}"

                :estimate-size="80"
                :item-class="'list-item-dynamic'"/>
            </b-tab>
          </b-tabs>
        </div>
        <!-- <p class="traits-list" v-for="trait in traits" :key="trait.name"> {{trait.name}} - {{trait.description}}</p> -->
      </div>
    </div>
  </div>
</template>

<script>
import VirtualList from 'vue-virtual-scroll-list'
import { BTabs, BTab, BButton } from 'bootstrap-vue'
import _ from 'lodash';

import HelloWorld from './components/HelloWorld.vue'
import statBlock from './components/statBlock.vue'
import propertyItem from './components/propertyItem.vue'
import sidebar from './components/sidebarComponent.vue'

import traitsJSON from './assets/traits.json';
import actionsJSON from './assets/actions.json';
import lActionsJSON from './assets/l_actions.json';
import MMJSON from './assets/mm_init.json';

export default {
  name: 'App',
  props:{
    // selectedTrait : Object
  },
  components: {
    'virtual-list': VirtualList,
    HelloWorld,
    statBlock,
    'b-tabs' : BTabs,
    'b-tab' : BTab,
    'b-button': BButton,

    sidebar
  },
  data(){
    return{
      traits : traitsJSON,
      actionsJSON,
      lActionsJSON,
      propertyComponent: propertyItem,
      selectedTraitIndex : -1,
      selectedActionIndex : -1,
      selectedLegendActionIndex : -1,
      tabIndex : 0,
      traits_monster : [],
      action_monster : [],
      legend_action_monster : [],
      init_stats : MMJSON.monster[0],
      alphabetical : false,
      directionUp : false,
      searchClick : false,
      query : '',
      toggleNotes : false,
    }
  },
  methods:{
    addItem(item, item_list ){
      // replace the {@creature}, {@condition} tags
      // shallow copy
      var item_copy = Object.assign({}, item)
      item_copy.description = item_copy.description.split("{@creature}").join(this.init_stats.name)
      ;
      this.handleDuplicate(item_list, item_copy);
      item_list.push(item_copy);
    },
    handleDuplicate(arr, x){
      var duplicate = arr.find((t) =>{
        return t.uid == x.uid;
      });

      if(duplicate){
        x.uid = duplicate.uid + '_' + Math.random().toString(9).substr(2, 9);
      }
    },
    initStats(){
      // Initialize traits for animated armor 
      var arr1 = this.traits.find((el) =>{
        return el.name == 'Antimagic Susceptibility';
      });
      
      var arr2 = this.traits.find((el) =>{
        return el.name == "False Appearance";
      });
      this.addItem(arr1, this.traits_monster);
      this.addItem(arr2, this.traits_monster);

      var action1 = arr1;
      var action2 = arr2;
      action1.name = "Multiattack."
      action1.description = "The armor makes two melee attacks."
      action2.name = "Slam."
      action2.description = "Melee Weapon Attack: +4 to hit, reach 5 ft., one target. Hit: 5 (1d6 + 2) bludgeoning damage."
      this.addItem(action1, this.action_monster);
      this.addItem(action2, this.action_monster);
    },
    traitSort: function(){
      if (this.alphabetical){
        this.traits = _.sortBy(this.traits, [function(t){return t.name}]);
      }else{
        this.traits = _.reverse(_.sortBy(this.traits, [function(t){return t.count}]));
      }
      this.alphabetical = !this.alphabetical;
    },
    actionSort: function(){
      if (this.alphabetical){
        this.actionsJSON = _.sortBy(this.actionsJSON, [function(t){return t.name}]);
      }else{
        this.actionsJSON = _.reverse(_.sortBy(this.actionsJSON, [function(t){return t.count}]));
      }
      this.alphabetical = !this.alphabetical;
    },
    legendActionSort: function(){
      if (this.alphabetical){
        this.lActionsJSON = _.sortBy(this.lActionsJSON, [function(t){return t.name}]);
      }else{
        this.lActionsJSON = _.reverse(_.sortBy(this.lActionsJSON, [function(t){return t.count}]));
      }
      this.alphabetical = !this.alphabetical;
    },
    reverseList: function(){
      if (this.alphabetical){
        this.traits = _.sortBy(this.traits, [function(t){return t.name}]).reverse()
      }else{
        this.traits = _.sortBy(this.traits, [function(t){return t.count}]);
      }
      // this.actionsJSON = _.reverse(this.actionsJSON);
      // this.lActionsJSON = _.reverse(this.lActionsJSON);
      // this.alphabetical = !this.alphabetical;
    },
  },
  computed:{
    filteredTraits:function() {
      if(!this.query){
        return this.traits;
      }
      var vm = this;
      return this.traits.filter(t => {
        return t.name.toLowerCase().includes(vm.query.toLowerCase()) 
                || t.description.toLowerCase().includes(vm.query.toLowerCase());
      })
   },
   filteredAction:function() {
      if(!this.query){
        return this.actionsJSON;
      }
      var vm = this;
      return this.actionsJSON.filter(t => {
        return t.name.toLowerCase().includes(vm.query.toLowerCase()) 
                || t.description.toLowerCase().includes(vm.query.toLowerCase());
      })
   },
   filteredLegendAction:function() {
      if(!this.query){
        return this.lActionsJSON;
      }
      var vm = this;
      return this.lActionsJSON.filter(t => {
        return t.name.toLowerCase().includes(vm.query.toLowerCase()) 
                || t.description.toLowerCase().includes(vm.query.toLowerCase());
      })
   }
  },
  created () {
    // detecting change checked value from item component event.
    this.$on('traitAdded', (uid, index) => {
      this.selectedTraitIndex = index;
      this.addItem(this.traits[index], this.traits_monster);
    })

    this.$on('actionAdded', (uid, index) => {
      this.selectedActionIndex = index;
      this.addItem(this.actionsJSON[index], this.action_monster);
    })

    this.$on('legendActionAdded', (uid, index) => {
      this.selectedLegendActionIndex = index;
      this.addItem(this.lActionsJSON[index], this.legend_action_monster);
    })

    this.initStats()
  },
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  margin-top: 60px;
}

.toggleButton{
  position: absolute;
  left:360px;
}

.toggleButtonToggled{
  left:10px;
}

.tabs{
  box-shadow: 0 0 1em rgba(134,116,83,0.5);
  margin-top: 40px;
  /* box-shadow: 0 30px 40px rgba(0,0,0,.1); */
}

.list-dynamic{
  width: 500px;
  height: 500px;
  /* border: 1px solid; */
  /* border-radius: 3px; */
  overflow-y: auto;
  /* border-color: dimgray; */
  margin-top:20px;
}
.list-item-dynamic {
  display: flex;
  align-items: center;
  padding: 0.5em;
  border-bottom: 1px solid;
  border-color: lightgray;
}

.traits-list{
  display: block;
}
/* ------------------------------------------ */
.scroll-touch {
-webkit-overflow-scrolling: touch;}
  /* width */
  ::-webkit-scrollbar {
    width: 10px;
  }
  /* Track */
  ::-webkit-scrollbar-track {
    background: #f4f4f4;
  }
  /* Handle */
  ::-webkit-scrollbar-thumb {
    border-radius: 0px;
    background: rgba(0, 0, 0, 0.12);
  }
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #b2b2b2;
  }
/* ------------------------------------------- */
.item{
  padding: 30px;
  /* padding-left: 40px; */
  display: inline-block;
  vertical-align: top;
  margin:auto;
  text-align: left;
}

#container{
  text-align: center;
  margin-left:350px;
  padding: 0px 10px;
}

.containerToggle{
  margin-left:0px !important;
}

/* ------------------------------------------ */
.queryBox{
  margin-left:20px; 
  height: 28px;
  width: 200px;
  font-size: 15px;
}

.queryAnimation-enter-active, .queryAnimation-leave-active {
  transition: all .3s;
}
.queryAnimation-enter, .queryAnimation-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(-18px);
  width: 0;
}

.filterButton{
  transform: rotate(180deg);
}

.filterAnimation-enter-active, .filterAnimation-leave-active {
  transition: all .3s;
}
.filterAnimation-enter, .filterAnimation-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: rotate(0deg);
}
</style>